export enum ExtraContributionScenario {
	Earlier = "earlier",
	More = "more",
}
